import { t } from "i18next";
const specialCharsRegex = /[^a-zA-Z0-9\s]/;
const specialCharsRegexWithDot = /[^a-zA-Z0-9\s.]/;

export const validateNotEmpty = (fieldName) => (_, value) => {
  if (value !== undefined && value !== "" && value?.trim() === "") {
    return Promise.reject(`Please enter ${fieldName}!`);
  } else if (specialCharsRegex?.test(value)) {
    return Promise.reject(t("SPECIAL_CHAR_NOT_ALLOWED_KEY"));
  }
  return Promise.resolve();
};

export const validateEmail = (fieldName) => (_, value) => {
  if (value !== undefined && value !== "" && value?.trim() === "") {
    return Promise.reject(`Please enter ${fieldName}!`);
  }
  if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
    return Promise.reject(t("EMAIL_VALIDATION_MSG")); // Reject invalid email format
  }
  return Promise.resolve();
};

export const validateName = (fieldName) => (_, value) => {
  if (value !== undefined && value !== "" && value?.trim() === "") {
    return Promise.reject(`Please enter ${fieldName}!`);
  } else if (specialCharsRegexWithDot?.test(value)) {
    return Promise.reject(t("SPECIAL_CHAR_NOT_ALLOWED_KEY"));
  }
  return Promise.resolve();
};
